// How efficiently you worked on a machine in one session, from its 1 Hz
// telemetry (see summary.js for the row shape):
//   w_per_beat    average watts per bpm of heart rate. Rises as you get
//                 fitter, so it's a trend to compare like with like.
//   drift_pct     aerobic decoupling (Friel's Pa:HR): how much watts per beat
//                 fell from the first half of a steady effort to the second.
//                 Under 5% is a sign of a solid aerobic base. Only for 20+
//                 minutes of steady work.
//   m_per_stroke  rower: metres each stroke moves you, from pace and rate.

const MIN_HR_S = 300; // 5 minutes of power and heart rate together
const MIN_DRIFT_S = 1200; // 20 minutes for decoupling
const MAX_DRIFT_CV = 0.15; // power steadier than this
const MIN_STROKE_S = 60;

const mean = (xs) => xs.reduce((a, b) => a + b, 0) / xs.length;
const cv = (xs) => {
  const m = mean(xs);
  if (!m) return Infinity;
  return Math.sqrt(mean(xs.map((x) => (x - m) ** 2))) / m;
};
const ratio = (rows) => mean(rows.map((r) => r.w)) / mean(rows.map((r) => r.hr));

/** The figures above for one machine type, or null when there's too little. */
export function machineEfficiency(samples, dev) {
  if (!Array.isArray(samples)) return null;
  const out = {};
  const both = samples.filter((r) => r && r.dev === dev && r.w > 0 && r.hr > 0);
  if (both.length >= MIN_HR_S) {
    out.w_per_beat = Math.round(ratio(both) * 100) / 100;
    if (both.length >= MIN_DRIFT_S) {
      // Leave out the first tenth, where heart rate is still catching up.
      const body = both.slice(Math.floor(both.length / 10));
      if (cv(body.map((r) => r.w)) <= MAX_DRIFT_CV) {
        const half = Math.floor(body.length / 2);
        const first = ratio(body.slice(0, half));
        const second = ratio(body.slice(half));
        out.drift_pct = Math.round(((first - second) / first) * 1000) / 10;
      }
    }
  }
  if (dev === "rower") {
    const strokes = samples.filter((r) => r && r.dev === "rower" && r.p > 0 && r.spm > 0);
    if (strokes.length >= MIN_STROKE_S) {
      out.m_per_stroke = Math.round(mean(strokes.map((r) => 500 / r.p / (r.spm / 60))) * 10) / 10;
    }
  }
  return Object.keys(out).length ? out : null;
}
